import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { SivaGoalAccomplishmentService } from 'src/api/v2';

const useDownloadGoalOverviewReport = (
  clusterStatusId: string | undefined,
  reportingYear: number | undefined,
) => {
  const [service] = useState(new SivaGoalAccomplishmentService());

  const fetchReport = useMutation({
    mutationFn: async () => {
      return await service.getGoalAccomplishmentOverviewReport(clusterStatusId ?? '', reportingYear);
    },
  });
  return { fetchReport };
};

export default useDownloadGoalOverviewReport;
